import { useTenantNavigate } from '@app-store'
import { PropsWithChildren, useEffect } from 'react'
import { RootState, useAppSelector } from '../utils/agent.store'
import { permissionObject } from '../utils/helperFunctions'
import {
  canAccessGlobalPermissionSetConfiguration,
  selectIsSupportUser,
} from '../utils/helperFunctions'
import { PERMISSION_MODULES } from '../utils/constants'

const NavigateToPage: React.FC<{ url: string }> = ({ url }) => {
  const navigate = useTenantNavigate()
  useEffect(() => {
    navigate(url)
  }, [url])
  return <></>
}

export const SupervisorProtectedRoute: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const isAdmin = useAppSelector(
    (state: RootState) => state.authUser.user?.superAdmin
  )
  const isSupportUser = useAppSelector(selectIsSupportUser)
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.programPermissions
  )

  if (isSupportUser && canAccessGlobalPermissionSetConfiguration()) {
    return children
  }

  if (
    !isAdmin &&
    Object.keys(programPermissions).length &&
    !permissionObject.Permission_Set_Assignment_View(
      programPermissions,
      PERMISSION_MODULES.PERMISSION_ASSIGNMENT,
      'View Only'
    )
  ) {
    return <NavigateToPage url="/" />
  }
  if (
    isAdmin ||
    canAccessGlobalPermissionSetConfiguration() ||
    permissionObject.Permission_Set_Assignment_View(
      programPermissions,
      PERMISSION_MODULES.PERMISSION_ASSIGNMENT,
      'View Only'
    )
  ) {
    return children
  } else {
    return null
  }
}
